﻿var jquery = require("jquery");
//var HabUtils = require("../Global/habitaclia-utils");
var HabEvents = require("../Global/habitaclia-events");
var cookieService = require('../Global/cookie-service');
var storageService = require( '../Global/storage-service').default;

(function () {
    "use strict";

    var LiveNotifications = function (LiveNotificationDTO) {
        this.__STORAGE_ITEM = 'livevisiblelist';
        this.__liveNotificationDTO = LiveNotificationDTO;
        this.__firstTimeToGetLiveNotifications = 5000;
        this.__defaultTimeToGetLiveNotifications = 20000;
        this.__liveInfoInterval;
        this.__sBaseTitle = document.title;
        this.firstHour = 6;
        this.isWindowFocus = true;
        this.numberNotificationsCalls = 100;
        this.countNotificationsCalls = 0;
        this.maxNotifications = 50;
        this.__$liveContainer = jquery('#js-live-container');
        this.__liveContainer = document.getElementById('js-live-container');
        this.__maxTimeLive = 18000000;
        this.storageService = new storageService();
        this.hasLocalStorage = this.storageService.checkLocalStorage();
		this.dataToLocal = [];
		this.dataToLocalAux = [];
		
		if (this.__liveNotificationDTO.notificacionesLiveActivadas === 'true' && this.__$liveContainer.length > 0) {
			__setLiveNotifications.call(this);
		}

		if (this.hasLocalStorage) {
		    __getLocalNotifications.call(this);
		}
	};

    var __setLiveNotifications = function () {
        var self = this;
        if (!!this.__liveContainer) {
            this.__$liveContainer.css('display', 'block');
            __init__callAjaxLiveInfo.call(this);
        }
        jquery(window).focus(function () {
            self.isWindowFocus = true;
        });
        jquery(window).blur(function () {
            self.isWindowFocus = false;
        });

    };
    var __initLiveNotificaction = function (info) {
        var self = this;
        var $newItem, liveTemplate, innerLiveTemplate;
        if (!!info.id) {
            if (info.id.startsWith('info')) {
                if (!cookieService.hasCookie(info.id) || cookieService.getCookie(info.id) === 'visible') {
                    if (jquery('#' + info.id).length > 0) {
                        __setLiveNoVisible.call(self, jquery('#' + info.id));
                    }
                    var newAnchor = document.getElementById("{{liveItem}}").cloneNode(true);
                    innerLiveTemplate = newAnchor.innerHTML;
                    innerLiveTemplate = innerLiveTemplate.replace("{{image}}", info.html);
                    newAnchor.innerHTML = innerLiveTemplate.replace("{{info}}", '');
                    newAnchor.setAttribute("data-gtmid", info.id);
                    newAnchor.setAttribute("data-id", info.id);
                    newAnchor.setAttribute("data-url", info.href);
                    newAnchor.id = info.id;
                    newAnchor.className = info.classes;
                    this.__liveContainer.insertBefore(newAnchor, this.__liveContainer.firstChild);
                    $newItem = jquery('#' + info.id);
                    __setLiveVisible.call(this, $newItem);
                    $newItem.click(function (e) {
                        e.preventDefault();
                        var $target = jquery(e.target);
                        if ($target.hasClass('live-item-close')) {
                            jquery.publish(HabEvents.EventsEnum.NotificationLive, ['close', 'alerta-ficha']);
                            __setLiveNoVisible.call(self, $target.parent('.live-item'));
                        } else {
                            jquery.publish(HabEvents.EventsEnum.NotificationLive, ['click', 'alerta-ficha']);
                            window.open(info.href, '_blank');
                            __setLiveNoVisible.call(self, jquery(e.currentTarget));
                        }
                        cookieService.removeCookie(info.id);
                        cookieService.setCookie(info.id, 'closed', Infinity);
                    });
                }
            } else {
                var checkId = "#live-" + info.id;
                if (jquery(checkId).length > 0) {
                    jquery(checkId).remove();
                }
                liveTemplate = document.getElementById("{{liveItem}}").cloneNode(true);
                var isMobileApp = this.__liveNotificationDTO.isMobileApp === 'True' ? true : false;
                liveTemplate.id = "live-" + info.id;
                innerLiveTemplate = liveTemplate.innerHTML;
                var imageHTML = '<img src="' + info.img + '"/>';
                imageHTML = imageHTML.replace("nodisponible.jpg", "livephoto" + (Math.round((Math.random() * 2) + 1)) + ".jpg");

                var datosAd = '';
                if (info.price !== "0" && info.price !== "99999998") {
                    datosAd += info.price + '€';
                }
                if (info.superficie !== "0") {
                    datosAd += '<span>' + info.superficie + 'm<sup>2</sup><span>';
                }
                if (info.hab !== "0" && info.hab !== "-1") {
                    datosAd += info.hab + 'hab.';
                }

                var dataHTML = '<p>' + datosAd + '</p>';

                innerLiveTemplate = innerLiveTemplate.replace("{{image}}", imageHTML);
                liveTemplate.innerHTML = innerLiveTemplate.replace("{{info}}", dataHTML);
                liveTemplate.href = this.__liveNotificationDTO.rutaMenu + '/' + info.url;
                liveTemplate.setAttribute("data-gtmid", info.id);
                liveTemplate.setAttribute("data-gtmname", "X-X-X");
                liveTemplate.setAttribute("data-gtmbrand", "X-X-X");
                liveTemplate.setAttribute("data-gtmprice", (info.price !== "0" ? info.price : "consultar"));
                liveTemplate.setAttribute("data-gtmcategory", (info.price !== "0" ? info.price : "consultar"));
                liveTemplate.setAttribute("data-gtmvariant", "X");
                liveTemplate.setAttribute("data-gtmlist", "busqueda-live");
                liveTemplate.setAttribute("data-gtmposition", "1");
                liveTemplate.setAttribute("data-url", liveTemplate.href);
                liveTemplate.setAttribute("data-ismobileapp", isMobileApp);

                if (isMobileApp) {
                    liveTemplate.target = "_self";
                    liveTemplate.setAttribute("data-target", "_self");
                } else {
                    liveTemplate.target = "_blank";
                    liveTemplate.setAttribute("data-target", "_blank");
                }
                this.__liveContainer.insertBefore(liveTemplate, this.__liveContainer.firstChild);

                $newItem = jquery("#live-" + info.id);

                $newItem.find('.live-item-' + info.tipo).removeClass('hide-none');
                $newItem.click(function (e) {
                    e.preventDefault();
                    var $target = jquery(e.target);
                    if ($target.hasClass('live-item-close')) {
                        __setLiveNoVisible.call(self, $target.parent('.live-item'));
                    } else {
                        jquery.publish(HabEvents.GTMEcommerceEventsEnum.ClicGtmItemUrl, jquery(this).data());
                        jquery.publish(HabEvents.EventsEnum.NotificationLive, ['click', self.__liveNotificationDTO.nav]);
                        __gtmEventClickNotificacionLive.call(self);
                        __setLiveNoVisible.call(self, jquery(e.currentTarget));
                    }
                });
                __setLiveVisible.call(this, $newItem);
            }
        }
    };

    var __setLiveVisible = function ($item) {
        var self = this;
        $item.css('display', '');
        $item.animate({ height: '76px' }, 200, function () {
            $item.animate({ opacity: 1 }, 200);
        });
        jquery.publish(HabEvents.EventsEnum.NotificationLive, ['show', self.__liveNotificationDTO.nav]);
    };

    var __setLiveNoVisible = function ($item) {
        var self = this;
        __removeItemFromList.call(this, jquery($item).attr('data-gtmid'));
        $item.animate({
            opacity: 0,
            height: "0px",
            'margin-top': "0px",
            'margin-bottom': "0px"
        }, 400, function () {
            $item.remove();
            __removeFromTitlePage.call(self);
        });
        __setLiveOptionsVisible.call(this);
    };

    /*var stopLiveNotifications = function () {
		if (typeof (this.__liveInfoInterval) === "number") {
			console.log("Stopping live notifications...");
			clearInterval(this.__liveInfoInterval);
			this.__liveInfoInterval = undefined;
		}
	};

	var startLiveNotifications = function () {
		if (typeof (this.__liveInfoInterval) === "undefined") {
			console.log("Starting live notifications...");
			__init__callAjaxLiveInfo();
		}
	};*/

    var __init__callAjaxLiveInfo = function () {
        var self = this;
        setTimeout(__callAjaxLiveInfo.call(self), this.__firstTimeToGetLiveNotifications);
        this.__liveInfoInterval = setInterval(
            function () {
                __callAjaxLiveInfo.call(self);
            }, this.__defaultTimeToGetLiveNotifications
         );
    };

    var __countNumberNotifications = function () {
        this.numberOfItems = this.__$liveContainer.children().length - 1;
    };

    var __callAjaxLiveInfo = function () {
        var self = this;
        var timeoutAjax = 10000;
        var urlGetLiveInfo = this.__liveNotificationDTO.rutaMenu + "/dotnet/NotificacionesLiveListado/GetNotificacionesLiveListado";
        var paramP = "p=" + this.__liveNotificationDTO.paramP;
        var paramForm = jquery(document.frmParametros).serialize();
        var dataLive = paramP + "&" + paramForm;
        __countNumberNotifications.call(this);
        var actualTime = new Date();
        this.actualHour = actualTime.getUTCHours();
        if (this.isWindowFocus && this.actualHour > this.firstHour) {
            if (this.numberNotificationsCalls > this.countNotificationsCalls && this.maxNotifications > this.numberOfItems) {
                jquery.ajax({
                    url: urlGetLiveInfo,
                    type: "POST",
                    data: dataLive,
                    dataType: "json",
                    timeout: timeoutAjax,
                    success: function (infoInmuebles) {
                        self.countNotificationsCalls = self.countNotificationsCalls + 1;
                        console.log("Calling Live Info...");
                        if (infoInmuebles !== "") {
                            var jsonInmuebles = JSON.parse(infoInmuebles);
                            var longitudInfoInmuebles = jsonInmuebles.length;
                            if (self.hasLocalStorage) {
                                if (self.dataToLocal !== undefined) {
                                    self.dataToLocal = self.dataToLocal.concat(jsonInmuebles);
                                } else {
                                    self.dataToLocal = jsonInmuebles;
                                }
                            }

                            if (longitudInfoInmuebles > 0) {
                                for (var i = 0; i < longitudInfoInmuebles; i++) {
                                    __initLiveNotificaction.call(self, jsonInmuebles[i]);
                                    __gtmEventShowNotificacionLive.call(self);
                                }
                                __updateFromTitlePage.call(self);
                            }
                            __updateLocalStorage.call(self);
                            __setLiveOptionsVisible.call(self);
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        var msg = "Error __callAjaxLiveInfo: " + " responseText: " + jqXHR.responseText + " textStatus: " + textStatus + " errorThrown: " + errorThrown;
                        throw msg;
                    }
                });
            }
        }
    };

    var __updateFromTitlePage = function () {
        if (this.__liveNotificationDTO.nav === "lista") {
            document.title = "(" + __getNumberOfLiveN() + ") " + this.__sBaseTitle;
        }
    };

    var __removeFromTitlePage = function () {
        if (this.__liveNotificationDTO.nav === "lista") {
            var contador = __getNumberOfLiveN();
            if (contador > 0) {
                document.title = "(" + contador + ") " + this.__sBaseTitle;
            } else {
                document.title = this.__sBaseTitle;
            }
        }
    };

    var __getNumberOfLiveN = function () {
        return jquery("#js-live-container").children().length - 2;
    };

    var __gtmEventShowNotificacionLive = function () {
        var sFrom = "listado";
        if (this.__liveNotificationDTO.nav === "ficha") {
            sFrom = "ficha";
        }
    };

    var __gtmEventClickNotificacionLive = function () {
        var sFrom = "listado";
        if (this.__liveNotificationDTO.nav === "ficha") {
            sFrom = "ficha";
        }
    };

    var __getLocalNotifications = function () {
        if (this.storageService.itemExist(this.__STORAGE_ITEM)) {

            var data = this.storageService.getItem(this.__STORAGE_ITEM);
            var actualDate = new Date();
            var actualTime = actualDate.getTime();
            var resTime = actualTime - data.lastdate;

            if (!!data.lastdate && resTime < this.__maxTimeLive) {
                var lastListJSON = data.list;
                    if (!this.storageService.areEqual(lastListJSON, this.dataToLocal)) {
                    __resetContainer.call(this);
                    this.dataToLocal = lastListJSON;
                    for (var i = 0; i < lastListJSON.length; i++) {
                        __initLiveNotificaction.call(this, lastListJSON[i]);
                    }
                }
            } else {
                __removeAll.call(this);
            }
        } else {
            __resetContainer.call(this);
        }
    };

    var __resetContainer = function () {
        var self = this;
        var liveTemplate = document.getElementById("{{liveItem}}").cloneNode(true);
        var liveOptions = document.getElementById("js-live-options").cloneNode(true);
        this.__$liveContainer.children().remove();
        this.__liveContainer.insertBefore(liveOptions, this.__liveContainer.firstChild);
        this.__liveContainer.insertBefore(liveTemplate, this.__liveContainer.firstChild);
        jquery('#js-live-delete-btn').click(function () {
            jquery.publish(HabEvents.EventsEnum.ClickRemoveAllLive);
            __removeAll.call(self);
        });
    };

    var __setLiveOptionsVisible = function () {
        __countNumberNotifications.call(this);
        if (this.numberOfItems > 2) {
            jquery('#js-live-options').css('display', 'block');
        } else {
            jquery('#js-live-options').css('display', 'none');
        }
    };

    var __removeAll = function () {
        this.dataToLocal = [];
        this.dataToLocalAux = [];
        this.numberOfItems = 0;
        if (this.hasLocalStorage === true) {
            if (this.storageService.itemExist(this.__STORAGE_ITEM)) {
                this.storageService.removeItem(this.__STORAGE_ITEM);
            }
        }
        __resetContainer.call(this);
        __setLiveOptionsVisible.call(this);
    };

    var __updateLocalStorage = function () {
        var data = new Date();
        if (this.hasLocalStorage === true) {
            if (this.storageService.itemExist(this.__STORAGE_ITEM)) {
                this.storageService.removeItem(this.__STORAGE_ITEM);
            }
            if (this.dataToLocal.length > 0) {
                this.storageService.setItem(this.__STORAGE_ITEM, { lastdate: data.getTime(), list: this.dataToLocal });
            }
        }
    };

    var __removeItemFromList = function (idItem) {
        var numberItemLocal = this.dataToLocal.length;
        var newLocalList = [];
        for (var currentItem = 0; currentItem < numberItemLocal; currentItem++) {
            if (this.dataToLocal[currentItem].hasOwnProperty('id')) {
                if (this.dataToLocal[currentItem].id !== idItem.toString()) {
                    newLocalList.push(this.dataToLocal[currentItem]);
                }
            }
        }
        this.dataToLocal = newLocalList;
        __updateLocalStorage.call(this);
    };

    var __setLiveFromTemplate = function (ide, itemHTML, cssclasses, link) {
        if (!cookieService.hasCookie(ide) || cookieService.getCookie(ide) === 'visible') {
            var info = { id: ide, html: itemHTML, classes: cssclasses, href: link };
            cookieService.setCookie(ide, 'visible', Infinity);
            __initLiveNotificaction.call(this, info);
            if (this.hasLocalStorage) {
                if (this.dataToLocal !== undefined) {
                    this.dataToLocal = this.dataToLocal.concat(info);
                } else {
                    this.dataToLocal = info;
                }
            }
            __updateLocalStorage.call(this);
        }
    };

    LiveNotifications.prototype = {
        constructor: LiveNotifications,
        SetLiveNotifications: __setLiveNotifications,
        SetLiveFromTemplate: __setLiveFromTemplate,
    };

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = LiveNotifications;
    }
    else {
        window.LiveNotifications = LiveNotifications;
    }
}());